<div class="container">
  <div class="input-container">
    <label [for]="label">{{ required ? label + ' *' : label }}</label>

    @switch (type.toLocaleLowerCase()) {
    @case ('text') {
    <input pInputText [id]="label" class="input-field" [style.width]="width" aria-describedby="input-hint"
      [placeholder]="placeholder" [formControl]="control" />
    }
    @case ('textarea') {
    <textarea pInputTextarea class="input-field" rows="8" cols="30" [placeholder]="placeholder"
      [formControl]="control"></textarea>
    }
    @case ('number') {
    <p-inputnumber [id]="label" class="input-field" [style.width]="width" aria-describedby="input-hint"
      [placeholder]="placeholder" [min]="min" [max]="max" [formControl]="control" />
    }
    @case ('select') {
    <p-select [id]="label" aria-describedby="input-hint" [placeholder]="placeholder" [emptyMessage]="emptyMessage"
      [autoDisplayFirst]="false" [options]="options" [formControl]="control" styleClass="p-select-width"
      (onChange)="selectionChanged($event)" appendTo="body">
    </p-select>
    }
    @case ('date') {
    <p-datepicker [id]="label" class="input-field calendar-field" [style.width]="width" [formControl]="control"
      [showTime]="true" hourFormat="24" [placeholder]="placeholder" [showIcon]="true"></p-datepicker>
    }
    @case('time') {
    <p-datepicker [id]="label" class="input-field calendar-field" [style.width]="width" [formControl]="control"
      [showTime]="true" [timeOnly]="true" hourFormat="24" [placeholder]="placeholder" [showIcon]="true"></p-datepicker>
    }
    }

    @if (hasHint) {
    <span style="font-size: 0.8em" class="input-hint">{{ hint }}</span>
    }
    @if (hasBottomSpace) {
    <span style="font-size: 0.8em" class="input-hint">&nbsp;</span>
    }
  </div>
  @if (hasWNL) {
  <div class="wnl-checkbox">
    <p-checkbox inputId="wnl" [(ngModel)]="wnl" [binary]="true" label="WNL" (ngModelChange)="toggleWNL()" />
    <label for="wnl">WNL</label>
  </div>
  }
</div>